export default Object.freeze({
  NODE_ADDRESS: 'node_address',
  MAC_ADDRESS: 'mac_address'
});
